export const GET_HASHTAG = "GET_HASHTAG";
export const CREATE_NEW_HASHTAG = "CREATE_NEW_HASHTAG";
export const EDIT_HASHTAG = "EDIT_HASHTAG";
export const DELETE_HASHTAG = "DELETE_HASHTAG";

export const OPEN_HASHTAG_DIALOG = "OPEN_HASHTAG_DIALOG";
export const CLOSE_HASHTAG_DIALOG = "CLOSE_HASHTAG_DIALOG";
